import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LegacyXrefEditorComponent } from './legacy-xref-editor.component';

export interface LegacyXrefDialogData {
  dataFeedId: string;
  feedName: string;
}

/** Full-size popup shell around app-legacy-xref-editor - the grid was cramped rendered inline
 *  inside the (narrow) feed edit card, so it opens as its own dialog instead. */
@Component({
  selector: 'app-legacy-xref-dialog',
  standalone: true,
  templateUrl: './legacy-xref-dialog.component.html',
  styleUrls: ['./legacy-xref-dialog.component.css'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, LegacyXrefEditorComponent],
})
export class LegacyXrefDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LegacyXrefDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LegacyXrefDialogData,
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
